import { gql } from '@apollo/client';
import { TEMPORAL_THRESHOLD } from './fragment.temporalThrehold';

export const SENSOR = gql`
  ${TEMPORAL_THRESHOLD}
  fragment Sensor on ProcessVariable {
    id
    name
    staleDataTimeoutSeconds
    samplingRateSeconds
    displayUnit {
      id
      name
    }

    thresholds {
      valueInDisplayUnit
      hexColor
    }

    process {
      id
      name
    }
    temporalThresholdGroup {
      ...TemporalThreshold
    }
    influenceArcDisplayThreshold
    numericScale
  }
`;
